import { PayloadAction } from '@reduxjs/toolkit';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { logi } from '@shared/utils/utils_logs';
import { CONSTANTS__client } from '../../constants/CONSTANTS__client';
import { ENUM__connection_state } from '../../enums/ENUM__connection_state';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { STATE__network } from './STATE__network';

export const local_network_set_state = (state: ENUM__connection_state): PayloadAction<ENUM__connection_state> => ({
  type: ENUM__redux_action.NETWORK_SET_STATE,
  payload: state,
});

export const init_local_network_set_state = (state: STATE__network, action: PayloadAction<ENUM__connection_state>) => {
  state.state = action.payload;

  if (CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) logi(`🛜 CONNECTION\t\t\t${state.state}`, { namespace: ELoggerNamespaceShared.CLIENT_TO_SERVER });

  switch (action.payload) {
    case ENUM__connection_state.CONNECTION_ERROR: {
      state.connect_attempts_after_last_disconnect++;
      break;
    }
    case ENUM__connection_state.CONNECTION_ESTABLISHED: {
      state.connect_attempts_after_last_disconnect = 0;
      break;
    }
  }
  ENUM__connection_state;
};
